import { render } from "./px-loading.vue?vue&type=template&id=577299db&scoped=true&ts=true"
import script from "./px-loading.vue?vue&type=script&lang=ts"
export * from "./px-loading.vue?vue&type=script&lang=ts"

import "./px-loading.vue?vue&type=style&index=0&id=577299db&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-577299db"]])

export default __exports__